import { render } from "./Slogen.vue?vue&type=template&id=6ea69d06&scoped=true"
import script from "./Slogen.vue?vue&type=script&lang=js"
export * from "./Slogen.vue?vue&type=script&lang=js"

import "./Slogen.vue?vue&type=style&index=0&id=6ea69d06&lang=less&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea69d06"]])

export default __exports__